import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import ClerkAuthProvider from "./components/auth/ClerkAuthProvider";
import { MeProvider, RequireKind } from "./components/MeContext";
import { Shell } from "./components/Shell";
import Home from "./pages/Home";
import Directory from "./pages/Directory";
import VendorPublic from "./pages/VendorPublic";
import { SignInPage, SignUpPage } from "./pages/AuthPages";
import AppRedirect from "./pages/AppRedirect";
import CustomerHome from "./pages/customer/CustomerHome";
import RequestDetail from "./pages/customer/RequestDetail";
import CandidatePage from "./pages/customer/CandidatePage";
import JobWizard from "./pages/customer/JobWizard";
import VendorHome from "./pages/vendor/VendorHome";
import OpsHome from "./pages/ops/OpsHome";
import Apply from "./pages/Apply";
import { PaymentCancel, PaymentSuccess } from "./pages/PaymentResult";

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <MeProvider>
          <Shell>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/vendors/:slug" element={<VendorPublic />} />
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/app" element={<AppRedirect />} />
              <Route path="/customer" element={<RequireKind kind="customer"><CustomerHome /></RequireKind>} />
              <Route path="/customer/new" element={<RequireKind kind="customer"><JobWizard /></RequireKind>} />
              <Route path="/customer/requests/:id" element={<RequireKind kind="customer"><RequestDetail /></RequireKind>} />
              <Route path="/customer/requests/:id/candidates/:cid" element={<RequireKind kind="customer"><CandidatePage /></RequireKind>} />
              <Route path="/vendor" element={<RequireKind kind="vendor"><VendorHome /></RequireKind>} />
              <Route path="/ops" element={<RequireKind kind="ops"><OpsHome /></RequireKind>} />
              <Route path="*" element={<div className="mx-auto max-w-3xl px-4 py-16" data-testid="not-found-page"><h1 className="text-3xl font-extrabold">Page not found</h1><a href="/" className="btn btn-primary mt-6">Go home</a></div>} />
            </Routes>
          </Shell>
          <Toaster position="top-center" richColors />
        </MeProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}
